import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Content, Message } from 'rsuite';
import { first } from 'lodash/fp';
import * as PERMISSIONS from '../../../../constants/permissions/settings';
import { hasModifyAccess, viewAccess } from '../../../../helpers/permission';
import { fetchCurrentPantry } from '../../../../redux/Settings/sagas/portal/routines';
import {
  getPantry,
  getIsFetched as getIsFetchedPantry
} from '../../../../redux/Settings/selectors/portal/pantry';
import AccessControl from '../../../../components/AccessControl';
import AccessDenied from '../../../../components/AccessDenied';
import PageHeader from '../../../../components/PageHeader';
import PageLayout from '../../../../components/settings/portal/PageLayout';
import ContentLoader from '../../../../components/ContentLoader';
import SmtpAccountPage from '../../../../components/settings/portal/SmtpAccountPage';
import SetupPantryMessage from '../../../../components/settings/portal/SetupPantryMessage';
import { useSmtpAccounts } from '../../../../hooks/useSmtpAccounts';
import { getUserPermissionsAsMap } from '../../../../redux/selectors/permission';

export default () => {
  const dispatch = useDispatch();
  const isFetchedPantry = useSelector(getIsFetchedPantry);
  const { isFetching, accounts } = useSmtpAccounts();
  const smtpAccount = first(accounts);
  const pantrySite = useSelector(getPantry);
  const permissions = useSelector(getUserPermissionsAsMap);
  const allowEdit = hasModifyAccess(PERMISSIONS.SMTP, permissions);

  useEffect(
    () => {
      if (!isFetchedPantry) dispatch(fetchCurrentPantry());
    },
    [isFetchedPantry]
  );

  return (
    <PageLayout>
      <AccessControl
        allowOnlyFor={viewAccess(PERMISSIONS.SMTP)}
        fallback={<AccessDenied />}
      >
        <PageHeader title="SMTP Account" />
        {!allowEdit && (
          <Message
            showIcon
            type="info"
            description="You only have VIEW permission for Smtp Account. Editing form is restricted."
            style={{ marginLeft: 20, marginRight: 20 }}
          />
        )}
        {pantrySite &&
          !smtpAccount && (
            <Message
              showIcon
              type="info"
              description="Set up your SMTP Account to enable reservation email notifications."
              style={{ marginLeft: 20, marginRight: 20 }}
            />
          )}
        <Content style={{ marginTop: pantrySite ? 20 : 0 }}>
          {!isFetchedPantry && isFetching && <ContentLoader />}
          {!pantrySite && <SetupPantryMessage />}
          <SmtpAccountPage data={smtpAccount} disabled={!pantrySite} />
        </Content>
      </AccessControl>
    </PageLayout>
  );
};
